export const BASE_URL = process.env.VUE_APP_BASE_URL || "/api/v1";
export const SENTRY_PROKEY = process.env.VUE_APP_SENTRY_PROKEY || "";
export const SENTRY_PROID = process.env.VUE_APP_SENTRY_ID || "";
export const SENTRY_TAG = process.env.VUE_APP_SENTRY_TAG || "";
export const SENTRY_ENV = process.env.VUE_APP_ENV || "";
export const SENTRY_AUTH_TOKEN = process.env.VUE_APP_SENTRY_AUTH_TOKEN || "";

export default {
  BASE_URL,
  SENTRY_PROKEY,
  SENTRY_PROID,
  SENTRY_TAG,
  SENTRY_ENV,
  SENTRY_AUTH_TOKEN,
};